/* PIILI / transparent cart drawer shipping milestone. Checkout rates remain authoritative. */
(() => {
  'use strict';
  const THRESHOLD = 149900;
  const FLAT_SHIPPING = 14900;
  const fmt = new Intl.NumberFormat('tr-TR', {style:'currency',currency:'TRY'});
  const safe = n => Number.isSafeInteger(n) && n >= 0;
  const policy = cart => {
    if (!cart || cart.currency !== 'TRY' || window.Shopify?.country !== 'TR'
      || !cart.requires_shipping || !Array.isArray(cart.items)
      || !cart.items.length || !safe(cart.total_price)) return null;
    const total = cart.total_price;
    const remaining = Math.max(0, THRESHOLD - total);
    return {total,remaining,percent:Math.min(100,Math.max(0,Math.floor(total * 100 / THRESHOLD))),shipping:remaining===0?0:FLAT_SHIPPING};
  };
  const initialize = () => {
    const body = document.getElementById('PiiliCartDrawerBody');
    if (!body) return;
    let version = 0;
    let request = null;
    let scheduled = false;
    const status = text => {
      const summary = body.querySelector('.cart-summary');
      if (!summary) return null;
      let node = summary.querySelector('[data-piili-free-shipping]');
      if (!node) {
        node = document.createElement('div');
        node.dataset.piiliFreeShipping = '';
        node.className='piili-free-shipping';
        const rows = summary.querySelector('p');
        if (rows) rows.before(node);
        else summary.append(node);
      }
      if (text) node.textContent = text;
      return node;
    };
    const update = cart => {
      if (!body.querySelector('.cart-summary')) return;
      const state = policy(cart);
      if (!state) {
        body.querySelector('[data-piili-free-shipping]')?.remove();
        return;
      }
      const node = status();
      if (!node) return;
      let message=node.querySelector('[data-piili-ship-message]');
      let track=node.querySelector('[data-piili-ship-track]');
      if (!message || !track) {
        node.replaceChildren();
        message=document.createElement('p');
        message.dataset.piiliShipMessage='';
        message.setAttribute('role','status');
        message.setAttribute('aria-live','polite');
        track=document.createElement('div');
        track.className='piili-free-shipping__track';
        track.dataset.piiliShipTrack='';
        track.setAttribute('role','progressbar');
        track.setAttribute('aria-label','Ücretsiz kargo hedefine ilerleme');
        track.setAttribute('aria-valuemin','0');
        track.setAttribute('aria-valuemax','100');
        const fill=document.createElement('span');
        track.append(fill);
        node.append(message,track);
      }
      message.textContent = state.remaining
        ? `${fmt.format(state.remaining / 100)} daha ekle, kargon ücretsiz olsun.`
        : 'Ücretsiz kargo kazandın.';
      node.dataset.complete=state.remaining===0?'true':'false';
      track.setAttribute('aria-valuenow',String(state.percent));
      track.firstElementChild.style.width=state.percent+'%';
      node.dataset.shippingFee = String(state.shipping);
      node.dataset.subtotal = String(state.total);
    };
    const refresh = async () => {
      version++;
      const requestVersion = version;
      if (request) request.abort();
      request = new AbortController();
      try {
        const route=(window.Shopify?.routes?.root || '/').replace(/\/$/,'')+'/cart.js';
        const response=await fetch(route,{credentials:'same-origin',cache:'no-store',signal:request.signal});
        if (!response.ok) throw Error('CART_RATE_READ_UNAVAILABLE');
        const cart=await response.json();
        if (requestVersion===version) update(cart);
      } catch (e) {
        if (e?.name==='AbortError') return;
        if (requestVersion===version) body.querySelector('[data-piili-free-shipping]')?.remove();
      }
    };
    const queue = () => {
      if(scheduled) return;
      scheduled=true;
      queueMicrotask(()=>{scheduled=false;refresh();});
    };
    const observer=new MutationObserver(entries=>{
      if(entries.some(entry=>entry.target===body))queue();
    });
    observer.observe(body,{childList:true});
    document.addEventListener('piili:cart-discount-ended',queue);
    window.addEventListener('pageshow',queue);
    queue();
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
})();